
import React from 'react';

interface TermsCheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
}

const TermsCheckbox: React.FC<TermsCheckboxProps> = ({
  checked,
  onChange,
  error,
}) => {
  return (
    <>
      <div className="flex items-start mb-6">
        <div className="flex items-center h-5">
          <input
            id="terms"
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className="w-4 h-4 border border-gray-300 rounded accent-neobank-primary focus:ring-neobank-primary"
          />
        </div>
        <label htmlFor="terms" className="ml-2 text-sm text-gray-600">
          I accept the <button type="button" className="text-neobank-primary">Terms & Conditions</button>
        </label>
      </div>
      {error && <p className="mt-1 mb-4 text-sm text-red-600">{error}</p>}
    </>
  );
};

export default TermsCheckbox;
